import React from 'react'
import { createStackNavigator } from '../stack/createStackNavigator'
import { useTheme } from 'styled-components/native'
import LoginScreen from '../../screens/authentication/LoginScreen'
import AppNavigator from './AppNavigator'
import DocletPreviewScreen from '../../screens/doclets/DocletPreviewScreen'
import useCurrentUser from '../../hooks/useCurrentUser'

const Stack = createStackNavigator()

const RootNavigator = () => {
  const theme = useTheme()
  const { firebaseToken } = useCurrentUser()
  const screenOptions = {
    headerShown: false,
    cardStyle: {
      backgroundColor: theme.colors.appBackground,
      flex: 1
    }
  }

  return (
    <Stack.Navigator options={screenOptions}>
      {firebaseToken ? (
        <>
          <Stack.Screen
            name="App"
            component={AppNavigator}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name="DocletPreview"
            component={DocletPreviewScreen}
            options={{ headerShown: false }}
          />
        </>
      ) : (
        <Stack.Screen
          name="Login"
          component={LoginScreen}
          options={{ headerShown: false }}
        />
      )}
    </Stack.Navigator>
  )
}

export default RootNavigator
